import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

class Grid extends Component {
  getOptions() {
    return ({
      noDataText: 'Sem dados para exibir.'
      , paginationShowsTotal: this.renderPaginationShowsTotal
      , toolBar: this.renderGridToolBar
    });
  }

  renderPaginationShowsTotal(start, to, total) {
    return (
      <p>
        Exibindo resultados de <b>{start}</b> até <b>{to}</b>. Total de <b>{total}</b> registros.
      </p>
    );
  }

  renderGridToolBar(props) {
    return (
      <div className="col-md-12">
        <div className="row">
          <div className='col-md-12'>
            {props.components.searchPanel}
          </div>
        </div>
      </div>
    );
  }

  renderTableColumns() {
    if (this.props.columns) {
      return this.props.columns.map((column, key) => {
        return (
          <TableHeaderColumn columnTitle filterFormatted dataSort key={key} dataField={column.name} {...column}>{column.label}</TableHeaderColumn>
        );
      });
    }
  }

  render() {
    return (
      <BootstrapTable trClassName={this.props.trClassName} data={this.props.data} keyField={this.props.keyField} searchPlaceholder={'Pesquisar...'} options={this.props.options || this.getOptions()} striped hover search
        multiColumnSearch strictSearch pagination>
        {this.props.children || this.renderTableColumns()}
      </BootstrapTable>
    );
  }
}

export default Grid;


// WEBPACK FOOTER //
// ./src/modulos/componentes/Grid.js